'use strict';

import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

var _this;
class PhotoSwipeController {

	constructor() {

		_this = this;
		$('.gallery-block').each(function(index){
			$(this).attr('data-pswp-uid',index+1);
			$(this).find('a').click(function(e){
				e.preventDefault();
				_this.clickThumb($(this));
			});
		});

	}

	clickThumb(obj){
		let objGalleryWrap = obj.parents('.gallery-block');
		//console.log(obj.parents('.col-gallery').index());
		let indexGalleryClick = obj.parents('.col-gallery').index();
		_this.openPhotoSwipe(objGalleryWrap,indexGalleryClick)

	}

	openPhotoSwipe(objGalleryWrap,indexGalleryClick){

		let pswpElement = document.querySelectorAll('.pswp')[0];
		let options = {

			// define gallery index (for URL)
			//galleryUID: galleryElement.getAttribute('data-pswp-uid'),
			galleryUID:objGalleryWrap.attr('data-pswp-uid'),
			bgOpacity: 0.9,
			history: false,
			shareEl: false,
			//showHideOpacity: false,
			// pinchToClose: false,
			// closeOnScroll: false,
			// closeOnVerticalDrag: false,
			index: indexGalleryClick,
		};

		let items = _this.getItemsOfGallery(objGalleryWrap);

		let gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
		gallery.init();
	}

	getItemsOfGallery(objGalleryWrap){

		let items = [];

		objGalleryWrap.find('.wrap-img a').each(function(){

			let item = {
				src: $(this).attr('href'),
				w: $(this).attr('data-img-width'),
				h: $(this).attr('data-img-height'),
				title: $(this).find('img').attr('alt'),
			};

			items.push(item)

		});

		return items;

	}
}

export default PhotoSwipeController


// WEBPACK FOOTER //
// ./scripts/components/photoSwipeController.js